import { createFileRoute, notFound } from "@tanstack/react-router"
import { DEFAULT_OG_IMAGE, SITE_URL } from "@/lib/constants/site-url"
import { buildBakerySchema } from "@/lib/data/bakery-schema"
import ContactPage from "@/pages/contact"

const OG_IMAGE = DEFAULT_OG_IMAGE

export const Route = createFileRoute("/$countryCode/contact")({
  loader: async ({ params, context }) => {
    const { countryCode } = params
    const { queryClient } = context
    const { getRegion } = await import("@/lib/data/regions")

    const region = await queryClient.ensureQueryData({
      queryKey: ["region", countryCode],
      queryFn: () => getRegion({ country_code: countryCode }),
    })

    if (!region) {
      throw notFound()
    }

    return { countryCode, region }
  },
  head: () => {
    const title = "Contact Us | +Bake Cafe — Rancho Cucamonga, CA"
    const description =
      "Contact +Bake Cafe in Rancho Cucamonga. 8685 Base Line Rd, Suite B. Call (909) 256-4016 or email talktome@takeurseat.com. Open daily 7:30-3:30."
    const canonical = `${SITE_URL}/contact`

    const localBusinessSchema = buildBakerySchema()

    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
        { "@type": "ListItem", position: 2, name: "Contact", item: canonical },
      ],
    }

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonical },
        { property: "og:image", content: OG_IMAGE },
        { property: "og:site_name", content: "+Bake Cafe" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        { name: "twitter:image", content: OG_IMAGE },
      ],
      links: [{ rel: "canonical", href: canonical }],
      scripts: [
        { type: "application/ld+json", children: JSON.stringify(localBusinessSchema) },
        { type: "application/ld+json", children: JSON.stringify(breadcrumbSchema) },
      ],
    }
  },
  component: ContactPage,
})
